import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xc55zh7td: FaireProductEntity = {
  token: "p_5xc55zh7td",
  type: "product",
  name: "Free Range Swedish Dishcloth",
  brandToken: "b_a7kevhkvzk",
  brandName: "Ecologie",
  imageUrl:
    "https://cdn.faire.com/fastly/c2bdb2c9c63b7f9d85ecf3e73e129b8cb2cf890d8b869416e0bddbcbcce4ac84.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/198a5ba0694e3968a248681d2491a2e1c19c61984b16923880250bd46f767d6c.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Wipe spills from the countertop big or small. Multitasking Swedish dishcloths are compostable cellulose sponge cloths that tackle any household jobs. Plus, it's perfectly safe to use them with a full range of cleaning products and wash them over 200 times. Swedish dishcloths are versatile, super-absorbent, reusable cleaning cloths that take on the tasks of sponge, dishcloth, and paper towel. Count on it for just about everything.\n\nDimensions: W6.5 x L8in\nMaterial: 70% Cellulose, 30% Cotton\nCare Instructions: Machine wash warm lay flat to dry",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:23.058Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
